/**
 * This file should contain all reusable sizes, spacings, gutters and etc.
 */
export var size = {
  baseline: 4,
  minWidth: 1280,
  minWidthResponsive: 360,
  breakpointDesktop: 1200,
  breakpointSmall: 1440,
  gutter: 30,
  gutterMedium: 24,
  gutterSmall: 16,
  gridColumnsCount: 12,
  tableFont: 12,
  tableHeaderFont: 10,
  tableGroupHeaderFont: 13,
  appBarHeight: 60
};
export var breakPoint = {
  mobile: 600,
  tablet: 1024
};